import imageCompression from 'browser-image-compression';

export async function compressImage(
  file: File,
  options?: {
    maxSizeMB?: number;
    maxWidthOrHeight?: number;
  }
): Promise<Blob> {
  return await imageCompression(file, {
    maxSizeMB: options?.maxSizeMB ?? 1,
    maxWidthOrHeight: options?.maxWidthOrHeight ?? 1600,

    // fuerza compresión real
    initialQuality: 0.7,
    maxIteration: 10,
    alwaysKeepResolution: false,

    // convierte PNG → JPEG (clave para reducir peso)
    fileType: 'image/jpeg',

    useWebWorker: true,
  });
}
